import { convertObjectToArray } from '@/utils/tool'
// 子商城类型：普通/药品
export const SUBMALL_TYPE = {
  COMMON: 1,
  DRUG: 2
}
export const ID_TYPE = {
  1: '身份证',
  2: '护照',
  3: '回乡证',
  4: '台胞证',
  5: '其他'
}
export const SEX_TYPE = {
  1: '男',
  2: '女',
  0: '未知'
}

export const MARRIAGE_TYPE = {
  1: '未婚',
  2: '已婚'
}
export const RELATION_TYPE = [
  {
    value: 1,
    text: '本人'
  },
  {
    value: 2,
    text: '父母'
  },
  {
    value: 3,
    text: '子女'
  },
  {
    value: 4,
    text: '配偶'
  },
  {
    value: 5,
    text: '亲戚'
  },
  {
    value: 6,
    text: '朋友'
  },
  {
    value: 0,
    text: '其他'
  }
]
export const RELATION_TYPE_REMOVE_ME = [
  {
    value: 2,
    text: '父母'
  },
  {
    value: 3,
    text: '子女'
  },
  {
    value: 4,
    text: '配偶'
  },
  {
    value: 5,
    text: '亲戚'
  },
  {
    value: 6,
    text: '朋友'
  },
  {
    value: 0,
    text: '其他'
  }
]
export const BLOOD_TYPE = [
  {
    value: 1,
    text: 'A'
  },
  {
    value: 2,
    text: 'B'
  },
  {
    value: 3,
    text: 'O'
  },
  {
    value: 4,
    text: 'AB'
  }
]
export const GOODS_TYPE = {
  SERVICE: 1,
  PHYSICAL: 2,
  PRESCRIPTION: 3,
  NON_PRESCRIPTION: 4
}
// 收藏夹type
export const COLLECT_TYPE = {
  6: '商品',
  2: '文章',
  3: '视频',
  // 4: '草稿',
  // 5: '自测',
  1: '健康问答'
}
export const GOODS_THESIS_STATUS = {
  UP: 1,
  DOWN: 2
}
export const ID_TYPE_ARR = convertObjectToArray(ID_TYPE)
export const SEX_TYPE_ARR = convertObjectToArray(SEX_TYPE)

export const MARRIAGE_TYPE_ARR = convertObjectToArray(MARRIAGE_TYPE)
export const COLLECT_TYPE_ARR = convertObjectToArray(COLLECT_TYPE)
// 客服电话
export const PHONE_NUM = brandConfig.daishuPhone
export const defaultMenu = [
  {
    icon: 'global_icon_home',
    text: '首页',
    link: '/home'
  },
  {
    icon: 'global_icon_welfare',
    text: '福利',
    link: '/mall'
  },
  {
    icon: 'global_icon_mine',
    text: '我的',
    link: '/mine'
  },
  {
    icon: 'global_icon_cart_white',
    text: '购物车',
    link: '/cart'
  }
]
// 首页优惠券channel值
export const CHANNEL = '004_01_0009_0001_01'

//设备
export const APPLIST = [
  {
    type: 1,
    img: 'https://public-10006067.file.myqcloud.com/upload/imagelist/ori/aff90db3d2055f8efaad64e2d3547318.jpeg',
    name: '血糖血压测试仪',
    text_1: '血压/血糖/脉搏',
    text_2: '迷你三合一一体机',
    model: ''
  },
  {
    type: 3,
    img: 'https://public-10006067.file.myqcloud.com/upload/imagelist/ori/26b6266af042be6b12d2084398bf29d8.jpeg',
    name: '体脂秤',
    text_1: '高颜值',
    text_2: '蓝牙体脂秤',
    p_y: 'tizhicheng',
    model: ''
  },
  {
    type: 2,
    img: 'https://public-10006067.file.myqcloud.com/upload/imagelist/ori/eadb27c5363e1b16a50c3838d66b1bfa.jpeg',
    name: '红外线体温计',
    text_1: '灵敏红外探头',
    text_2: '便携精准',
    p_y: 'tiwenji',
    model: ''
  },
  {
    type: 4,
    img: 'https://public-10006067.file.myqcloud.com/upload/imagelist/ori/cd98193ca792a69f82d2350b8d92169f.jpeg',
    name: '无线心电监测仪',
    text_1: '居家心脏防护',
    text_2: '好帮手',
    p_y: 'xindianyi',
    model: 'Wecardio UN'
  },
  {
    type: 5,
    // https://public-10006067.cos.ap-shanghai.myqcloud.com/upload/imagelist/ori/%E7%BC%96%E7%BB%84%203%402x.png
    img: 'https://public-10006067.cos.ap-shanghai.myqcloud.com/upload/imagelist/ori/xindian.png',
    name: '动态心电监测仪',
    text_1: '灵活监测',
    text_2: '健康心灵守护者',
    p_y: 'lien',
    model: 'FitPatch-H1'
  }
]

export const MINIAPPAPPLIST = [
  {
    type: 6,
    img: 'https://frontend-1251027788.cos.ap-guangzhou.myqcloud.com/service_component/health/device/uricacid.png',
    name: '尿酸分析仪',
    text_1: '家庭医用级',
    text_2: '专业测尿酸',
    p_y: 'lien',
    model: 'FitPatch-H1'
  },
  {
    type: 3,
    img: 'https://public-10006067.file.myqcloud.com/upload/imagelist/ori/26b6266af042be6b12d2084398bf29d8.jpeg',
    name: '体脂秤',
    text_1: '高颜值',
    text_2: '蓝牙体脂秤',
    p_y: 'tizhicheng',
    model: ''
  }
]

//跳转粒恩的密码
export const USER_PWD = '123456'

export const VIP_STATUS = {
  NOT_VIP: 1,
  IS_VIP: 2,
  EXPIRED_VIP: 3
}

// 用户环境
export const UACONFIG = {
  1: 'h5', // 浏览器
  2: 'app', // 袋鼠app
  3: 'wechatMiniapp', // 体检小程序
  4: 'pocketMiniapp' //口袋小程序
}
